import React from "react";
import icon1 from "../../../Assets/about-us/aboutus-icon-1.png";
import icon2 from "../../../Assets/about-us/aboutus-icon-2.png";
import icon3 from "../../../Assets/about-us/aboutus-icon-3.png";
import image1 from "../../../Assets/about-us/story-image-1.png";
import image2 from "../../../Assets/about-us/image-2.png";
import image3 from "../../../Assets/about-us/image-3.png";
import image4 from "../../../Assets/about-us/image-4.png";
import image5 from "../../../Assets/about-us/image-5.png";
import video from "../../../Assets/about-us/kalinga-bio-about-video.mp4";

const Story = () => {
  const card = [
    {
      icon: icon1,
      name: "25 Years Of Experience",
      desc: "All about planting and growing",
    },
    {
      icon: icon2,
      name: "Experienced Workers",
      desc: "All about planting and growing",
    },
    {
      icon: icon3,
      name: "100+ Awards Win",
      desc: "All about planting and growing",
    },
  ];

  return (
    <>
      {/* ── TOP CARDS ── */}
      <div className="w-full px-4 sm:px-6 md:px-10 py-6 sm:py-10 flex flex-col items-center bg-yellow-50/30">
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 w-full bg-gradient-to-b gap-5 from-[#DFECB6] to-[#F9FDED] p-6 rounded-2xl shadow-inner">
          {card.map((item, index) => (
            <div
              key={index}
              className="flex gap-3 w-full p-5 items-start bg-white rounded-xl shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 border border-transparent hover:border-[#92AD36]/30"
            >
              <img src={item.icon} alt="" className="h-12 w-12" />
              <div className="flex flex-col items-start">
                <span className="font-semibold text-base">{item.name}</span>
                <span className="text-sm">{item.desc}</span>
              </div>
            </div>
          ))}
        </div>

        {/* ── MISSION + VISION  ── */}
        <div className="relative w-full mt-16 overflow-hidden">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 w-full items-center">
            {/* ── LEFT — Mission ── */}
            <div className="flex flex-col w-full">
              <p className="text-[#92AD36] text-sm font-semibold tracking-widest uppercase">
                Story Of Glowry
              </p>
              <h2 className="text-3xl md:text-4xl font-serif text-[#000000] mt-2 leading-tight">
                Our Mission
              </h2>
              <p className="text-sm text-gray-600 tracking-wide leading-relaxed mt-4">
                Our mission is to provide high-quality, efficient, and
                cost-effective agricultural products through continuous
                technological innovation, supporting sustainable farming
                methods, minimizing environmental footprints, and ensuring a
                "green" future for farming.
              </p>
              <ul className="mt-5 space-y-3">
                {[
                  "Controls harmful pests",
                  "Safe for environment",
                  "Targets larvae effectively",
                  "Supports sustainable farming",
                ].map((point, i) => (
                  <li
                    key={i}
                    className="flex items-center gap-2 text-sm text-gray-700"
                  >
                    <span className="w-2 h-2 rounded-full bg-gray-800 flex-shrink-0" />
                    {point}
                  </li>
                ))}
              </ul>
            </div>

            <div className="relative flex items-center justify-center w-full sm:mt-28">
              <div className="relative z-10 w-full overflow-hidden">
                <video
                  autoPlay
                  muted
                  loop
                  controls
                  className="w-full  object-cover hover:scale-105 transition duration-500 rounded-xl"
                >
                  <source src={video} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>

            {/* ── RIGHT — Vision ── */}
            <div className="flex flex-col items-end text-right w-full">
              <p className="text-[#92AD36] text-sm font-semibold tracking-widest uppercase">
                Story Of Glowry
              </p>
              <h2 className="text-3xl md:text-4xl font-serif text-[#000000] mt-2 leading-tight">
                Our Vision
              </h2>
              <p className="text-sm text-gray-600 tracking-wide leading-relaxed mt-4">
                Our vision is to create a sustainable, technology-driven, and
                prosperous future of farmer by providing them with superior
                Agri-inputs, knowledge and converting agricultural produce into
                high-value products, reducing post-harvest losses, and boosting
                economic returns.
              </p>
              <ul className="mt-5 space-y-3">
                {[
                  "Controls harmful pests",
                  "Safe for environment",
                  "Targets larvae effectively",
                  "Supports sustainable farming",
                ].map((point, i) => (
                  <li
                    key={i}
                    className="flex items-center justify-end gap-2 text-sm text-gray-700"
                  >
                    {point}
                    <span className="w-2 h-2 rounded-full bg-gray-800 flex-shrink-0" />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* ── TIMELINE SECTION ── */}
      <div className="w-full bg-gradient-to-b from-[#1A3617] to-[#53744F] py-6 sm:py-10 mt-10 px-4 sm:px-6 md:px-10">
        <p className="text-[#92AD36] text-sm font-semibold tracking-wide">
          STORY OF GLOWRY
        </p>

        <div className="flex flex-col md:flex-row gap-6 md:gap-10 justify-between w-full items-start md:items-center">
          <div className="flex flex-col w-full">
            <h2 className="text-2xl md:text-4xl font-serif  text-[#FFFFFF] mt-3">
              Our KalingaBio Success Story
            </h2>
          </div>
          <p className="w-full text-base text-white/60 mt-2">
            Welcome to Kalinga Bio Ferti-Chem. As the Managing Director, I am
            honoured to lead a company dedicated to improving Odisha’s
            agriculture. Guided by the vision of our Founder, Mr. Brundaban
            Mallick, we focus on innovation, quality, and sustainability.
          </p>
        </div>

        {/* ROW 1 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 w-full gap-6 mt-14">
          <div className="flex flex-col items-center justify-center text-base transition">
            <p className="text-white/60 max-w-sm text-start">
              At, Kalinga Bio Ferti-Chem we are providing high-quality
              agrochemical products using technically advanced equipments for
              production and also well-equipped laboratory for analysis of raw
              materials and finished products. the latest technology and quality
              raw materials. The company is managed by highly skilled and
              qualified professionals who have adequate knowledge about the
              products.
            </p>
          </div>

          <img
            src={image2}
            alt=""
            className="w-full rounded-xl shadow-md hover:scale-105 transition duration-300"
          />

          <div className="flex flex-col items-center justify-center w-full text-base">
            <p className="text-white/60 max-w-sm text-start">
              Our aim is to help farmers of Odisha to enhance their productivity
              and success. Through continuous research and development, we
              create advanced agrochemical solutions and promote safe farming
              practices. We also organize training sessions and events to
              educate farmers for helping them achieve better results.
            </p>
          </div>

          <img
            src={image3}
            alt=""
            className="w-full rounded-xl shadow-md hover:scale-105 transition duration-300"
          />
        </div>

        {/* TIMELINE LINE */}
        <div className="relative w-full my-20">
          <div className="h-[2px] w-full bg-gradient-to-r from-transparent via-[#92AD36]/40 to-transparent" />
          <div className="absolute top-1/2 left-0 w-full flex justify-between -translate-y-1/2 px-6">
            {[...Array(5)].map((_, i) => (
              <span
                key={i}
                className="w-3 h-3 bg-[#92AD36] rounded-full shadow-[0_0_10px_#92AD36]"
              />
            ))}
          </div>
        </div>

        {/* ROW 2 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 w-full gap-6 mt-20">
          <img
            src={image4}
            alt=""
            className="w-full rounded-xl shadow-md hover:scale-105 transition duration-300"
          />

          <div className="flex flex-col items-center justify-center text-base w-full">
            <p className="text-white/60 text-start max-w-sm">
              Our commitment to excellence spans various areas, including
              Micronutrients, PGR, Bio-fertilizers, Pesticides and Organic
              Fertilizers. With our state-of-the-art manufacturing facility and
              distribution networks, we ensure that our products are available
              to farmers all over Odisha.
            </p>
          </div>

          <img
            src={image5}
            alt=""
            className="w-full rounded-xl shadow-md hover:scale-105 transition duration-300"
          />

          <div className="flex flex-col items-center justify-center text-base w-full ">
            <p className="text-white/60 text-start max-w-sm">
              I want to express my gratitude to our dedicated team, loyal
              customers, and partners who have been instrumental in our success.
              Together, we are sowing the seeds of progress and nurturing a
              brighter future for agriculture. Thank you for considering Kalinga
              Bio Ferti-Chem Private Limited. We look forward to being your
              trusted partner in agriculture and to sharing a prosperous future
              together.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Story;
